import { render, staticRenderFns } from "./PartesPage.vue?vue&type=template&id=3c985b21&scoped=true"
import script from "./PartesPage.vue?vue&type=script&lang=js"
export * from "./PartesPage.vue?vue&type=script&lang=js"
import style0 from "./PartesPage.vue?vue&type=style&index=0&id=3c985b21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c985b21",
  null
  
)

export default component.exports